import React from 'react';
import Badge from 'react-bootstrap/Badge';
import Stack from 'react-bootstrap/Stack';
import './Badges.css';
type BadgeProps = {
  variant:
    | 'primary-1'
    | 'primary-2'
    | 'primary-3'
    | 'primary-4'
    | 'warning'
    | 'danger'
    | 'success'
    | 'info'; // must use variant as primary-1,primary-2,primary-3,primary-4,warning,danger,success,info
  badgeName: string;
  badgeType?: 'case1' | 'case2' | 'case3' | 'case4' | 'case5' | 'case6' | 'case7'; //badgeType should be case1,case2,case3,case4,case5,case6
  className?: string;
};
const BadgesComponent: React.FC<BadgeProps> = ({
  badgeType,
  variant,
  badgeName,
  className = '',
}) => {
  const badgeClass = `badges_class_main badge-${variant} ${badgeType} ${className}`; // Class names for badge
  const isPill =
    badgeType === 'case3' || badgeType === 'case4' || badgeType === 'case6'; // Determine if badge should be a pill

  return (
    <Stack direction="horizontal">
      <Badge className={badgeClass} pill={isPill}>
        {badgeName}
      </Badge>
    </Stack>
  );
};

export default BadgesComponent;
